import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import { Radio as SemanticRadio } from 'semantic-ui-react';

export const Container = styled.div`
  margin-top: 5px;
  padding: 0px 10px;
  width: 100%;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  :first-child {
    margin-top: 40px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WrapperContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`;

export const Link = styled.a``;

export const HeldButton = styled(ButtonLayoutComponent.Danger)``;

export const ReleaseButton = styled(ButtonLayoutComponent)`
  width: max-content;
`;

export const RecorderContent = styled.div`
  margin-top: 20px;
`;

export const Text = styled(TextLayoutComponent)``;

export const Radio = styled(SemanticRadio)`
  margin-right: 5px;
`;

export const RadioContainer = styled.div`
  display: flex;
  margin: 10px;
  align-items: center;
  cursor: pointer;
`;
